<div class="col-12">

  <div class="bs-callout bs-callout-info">
    <h5 class="titulo-bloco"> {{ title }} </h5>
    <hr />

    <!-- Search Filter -->
    <form (ngSubmit)="search()" novalidate>
      <ng-template #browseFilter></ng-template>

      <!-- Commands -->
      <div class="clearfix">
        <button type="button" *ngIf="showAdd" class="btn btn-sm btn-success float-start me-2" (click)="addNew($event)">
          Adicionar Novo </button>
        <button type="button" *ngIf="showExportExcel" class="btn btn-sm btn-dark float-start me-2"
          [ladda]="isExportExcel" (click)="exportExcel($event)"> Exportação Excel </button>

        <button type="button" *ngIf="showExportReport" class="btn btn-sm btn-dark float-start me-2" [ladda]="isExportReport"
          (click)="exportReport($event)"> {{exportReportLabel}} </button>

        <button type="button" *ngIf="showExportAnalysis" class="btn btn-sm btn-dark float-start" [ladda]="isExportingAnalysis"
          (click)="exportAnalysis($event)"> {{exportAnalysisLabel}} </button>

        <button type="submit" class="btn btn-sm btn-primary float-end" [ladda]='runningSearch'> Atualizar </button>
      </div>
    </form>
  </div>

  <div class="bs-callout bs-callout-info" style="padding-bottom: 45px;">
    <h6 class="card-header pb-2">{{globalMessage}}</h6>

    <!-- Search Results -->
    <app-datagrid [rows]="gridData" [columns]="columns" [pageSize]="pageSize" (datagridEvent)="datagridEvent($event)">
    </app-datagrid>

  </div>
</div>

<ng-template #modalConfirmDelete let-c="close" let-d="dismiss">
  <div class="modal-body" style="margin:25px;">
    <p><b>Confirma eliminação do registo ?</b></p>
    <div class="text-right">
      <button type="button" class="btn btn-danger" (click)="c('Confirm')">Yes, delete</button>
      <button type="button" class="btn btn-info" (click)="c('NoConfirm')">No</button>
    </div>
  </div>
</ng-template>

<ng-template #modalUploadFicheiro let-c="close" let-d="dismiss">
  <div class="modal-body" style="margin:10px;">
    <h4>Enviar anexo</h4>
    <div class="jumbotron p-3">
      <form>
        <div class="form-group input-group-sm">
          <label for="descritivo">Descritivo :</label>
          <input type="text" class="form-control input-sm" id="descritivo" name="popupDescription"
            [(ngModel)]="popupDescription">
        </div>
        <div class="form-group input-group-sm">
          <label for="observacoes">Observações :</label>
          <input type="text" class="form-control input-sm" id="observacoes" name="popupRemarks"
            [(ngModel)]="popupRemarks">
        </div>

        <hr class="my-4">

        <div class="form-group input-group-sm">
          <label for="ficheiro">Ficheiro :</label><br />
          <label class="btn">
            <input type="file" id="ficheiro" accept=".pdf" (change)="selectFile($event)" />
          </label>
        </div>

        <div class="text-right">
          <button type="button" class="btn btn-sm btn-success" [disabled]="!currentFile"
            (click)="upload($event)">Enviar</button>
        </div>
      </form>
    </div>

    <div *ngIf="message" class="alert alert-secondary" role="alert">{{ message }}</div>

    <div class="text-right">
      <button type="button" class="btn btn-sm btn-dark" (click)="c('NoConfirm')">Fechar</button> &nbsp;&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #modalAcompanhamento let-c="close" let-d="dismiss">
  <div class="modal-header m-2">
    <h4>Informaçao de acompanhamento</h4>
    <button type="button" class="btn btn-sm btn-outline-secondary close" data-dismiss="dialog" (click)="c('Close')">
      <span aria-hidden="true">&times;</span>
      <span class="sr-only">Close</span>
    </button>
  </div>
  <div class="modal-body m-2">
    <table class="table table-sm table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Data</th>
          <th scope="col">Comentário</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pia of popupListData; index as i" class="sm">
          <td><small>{{ pia.numLinha }}</small></td>
          <td><small>{{ pia.data | date: 'dd/MM/YYYY' }}</small></td>
          <td><small>{{ pia.comentario }}</small></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer m-2">
    <button type="button" class="btn btn-sm btn-secondary" (click)="c('Close')">Fechar</button>
  </div>
</ng-template>

<ng-template #modalRegistoKms let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4>Atualização de kms de viatura</h4>
  </div>
  <div class="modal-body" style="margin:1px;">
    <div class="jumbotron p-3">
      <form>
        <div class="form-group input-group-sm">
          <label for="kms">Nº de Kms :</label>
          <input type="number" class="form-control input-sm" style="width: 30%;" id="kms" name="popupKms"
            [(ngModel)]="popupKms">
        </div>
      </form>
    </div>
    <div *ngIf="message" class="alert alert-secondary">{{ message }}</div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!popupRegistoOk" class="btn btn-sm btn-success float-start" [disabled]="!popupKms"
      (click)="registaKms($event)">Enviar</button>
    <button type="button" class="btn btn-sm btn-dark float-end" (click)="c('NoConfirm')">Fechar</button> &nbsp;&nbsp;
  </div>
</ng-template>